export const beforeItems: string[] = [
  'Passi ore a cercare esercizi sparsi online',
  'Non sai se l’esercizio è adatto all’età della classe',
  'Improvvisi la lezione all’ultimo minuto',
  'La palestra è occupata e non hai un piano B',
  'Nessuna griglia di valutazione pronta da usare',
]

export const afterItems: string[] = [
  'Ogni lezione è già pronta, dalla pagina 1',
  'Progressione a spirale calibrata per età, dai 6 ai 19 anni',
  '64 unità già strutturate: attivazione, schede, banca esercizi, giochi',
  'Versione per palestra, mezza palestra, cortile e aula in ogni unità',
  'Griglie, rubriche e voti in decimi già scritti',
]

export const transformationStats: { value: string; label: string }[] = [
  { value: '8 Volumi', label: '+ 5 bonus, dalla 1ª primaria alla 5ª superiore' },
  { value: '64 Unità', label: 'già strutturate: attivazione, schede, banca esercizi, giochi' },
  { value: '100%', label: 'pronto da stampare, senza preparazione' },
]
